import { PatchMeta, SpicePatch, UnionPatch } from "..";
import { bytesMatch, replace, toHexString } from "../utils/binary";
import { createID } from "../utils/html";
import { Patcher } from ".";
import UnionPatchUI from "../../components/Patchs/UnionPatchUI";
import { Signal, createSignal } from "solid-js";

export class UnionPatcher implements Patcher {
    name: string;
    offset: number;

    tooltip: string | undefined;
    danger: string | undefined;
    patches: Array<PatchMeta & { patch: number[] }>;
    default: number;
    selected: Signal<number>;
    id: string;


    constructor(options: UnionPatch, baseAddr: number) {
        this.name = options.name;
        this.offset = typeof options.va !== 'undefined' ? options.va - baseAddr : options.offset;
        this.patches = options.patches;
        this.tooltip = options.tooltip;
        this.danger = options.danger;
        this.default = options.default ?? 0;

        this.selected = createSignal(-1);
        this.id = createID();
    }

    get uiOnly(): boolean {
        return false;
    }

    ui() {
        return UnionPatchUI(this);
    }

    validatePatch(file: Uint8Array) {
        const [_, setSelected] = this.selected;

        const enabledIndex = this.patches
            .findIndex(v => bytesMatch(file, this.offset, v.patch));

        setSelected(enabledIndex === -1 ? this.default : enabledIndex);

        if (enabledIndex != -1) {
            return { valid: true };
        }

        return { valid: false, message: '<b>' + this.name + '</b> 没有匹配的选项, 你是不是开错文件了?' }
    }

    applyPatch(file: Uint8Array) {
        const patch = this.getSelected();

        if (!patch) {
            throw new Error('patch not selected!');
        }

        replace(file, this.offset, patch.patch);
    }

    getSelected() {
        const [selected] = this.selected;
        return this.patches[selected()];
    }

    exportPatch2X(gameCode: string, dateCode: number, dllName: string): SpicePatch | undefined {
        return {
            name: this.name,
            description: this.tooltip || this.danger || '',
            gameCode,
            dateCode,
            type: 'union',
            patches: this.patches.map(v => ({
                name: v.name,
                type: 'union',
                patch: {
                    dllName,
                    data: toHexString(v.patch),
                    offset: this.offset,
                }
            }))
        }
    }

    exportPatch(gameCode: string, dateCode: number, dllName: string): SpicePatch | undefined {
        const patch = this.getSelected();
        const def = this.patches[this.default];

        if (!patch || patch == def) {
            return undefined;
        }

        return {
            dateCode,
            description: this.tooltip || this.danger || '',
            gameCode,
            name: `${this.name}: ${patch.name}`,
            preset: true,
            type: 'memory',
            patches: [{
                dataDisabled: toHexString(def.patch),
                dataEnabled: toHexString(patch.patch),
                dataOffset: this.offset,
                dllName,
            }],
        };
    }
}
